import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import {
  getWarehouseProcessStage,
  getWarehouseProcessStageAppServiceStage,
} from "../../../services/WarehouseStage/WarehouseStage";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import WarehouseProcessStageCreateModal from "./WarehouseProcessStageCreateModal";
import WarehouseProcessStageSwapModal from "./WarehouseProcessStageSwapModal";
import AdminMenu from "../../AdminMenu";
import WHProcessStageListAppServiceAddModal from "./WHProcessStageListAppServiceAddModal";
import {
  getAppService,
  getBrandAppService,
} from "../../../services/BrandAppServices";
import WHProcessStageListViewAppServiceAddModal from "./WHProcessStageListViewAppServiceAddModal";

const WarehouseProcessStageList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [warehouseStageData, setWarehouseStageData] = useState([]);
  
  const handleConfirmAndContinue = () => {
    setModalMenuVisible(true);
  };

  const [
    wHProcessStageListAppServiceAddModalVisible,
    setWHProcessStageListAppServiceAddModalVisible,
  ] = useState(false);
  const [
    wHProcessStageListViewAppServiceAddModalVisible,
    setWHProcessStageListViewAppServiceAddModalVisible,
  ] = useState(false);
  const [selectedAppServiceValue, setSelectedAppServiceValue] = useState(null);

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;
  const [loading, setLoading] = useState(false);

  const [warehouseStageModalVisible, setWarehouseStageModalVisible] =
    useState(false);

  const [
    warehouseProcessStageSwapModalVisible,
    setWarehouseProcessStageSwapModalVisible,
  ] = useState(false);

  const [selectedItemValue, setSelectedItemValue] = useState(null);

  const fetchWarehouseUser = () => {
    setLoading(true);
    getWarehouseProcessStage(id)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setWarehouseStageData(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    // getAppService()
    getBrandAppService(brandId)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          setSelectedAppServiceValue(res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchWarehouseUser();
  }, []);

  const receiveDataFromAppServiceAddModal = ({ success }) => {
    if (success) {
      fetchWarehouseUser();
    }
  };

  const [searchTerm, setSearchTerm] = useState("");

  const filterUserList = () => {
    return warehouseStageData.filter((item) => {
      const stage = item.stage?.toLowerCase();
      const matchesSearchTerm = stage?.includes(searchTerm.toLowerCase());
      return matchesSearchTerm;
    });
  };

  const filteredUserData = filterUserList();

  const receiveDataFromWarehouseStageModal = ({ success }) => {
    if (success) {
      fetchWarehouseUser();
      setSelectedItemValue(null);
    }
  };

  const renderCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Stage :
                  </p>
                  <p className="text-lg font-medium capitalize">{item.stage}</p>
                </div>

                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Priority
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {" "}
                      {item.priority}
                    </p>
                  </div>
                  <div className="flex gap-2">
                    <div
                      className="mr-4 mt-2"
                      onClick={() => {
                        setWHProcessStageListAppServiceAddModalVisible(true);
                        setSelectedItemValue(item);
                      }}
                    >
                      <i
                        className="pi pi-plus-circle"
                        style={{
                          fontSize: "20px",
                          cursor: "pointer",
                          color: "green",
                        }}
                      ></i>
                    </div>
                    <div
                      className="mr-4 mt-2"
                      onClick={() => {
                        setWarehouseProcessStageSwapModalVisible(true);
                        setSelectedItemValue(item);
                      }}
                    >
                      <i
                        className="pi pi-sort-alt"
                        style={{
                          fontSize: "20px",
                          cursor: "pointer",
                          color: "#2B70D7",
                        }}
                      ></i>
                    </div>
                    <div
                      className="mr-4 mt-2"
                      onClick={() => {
                        setWarehouseStageModalVisible(true);
                        setSelectedItemValue(item);
                      }}
                    >
                      <i
                        className="pi pi-pencil"
                        style={{
                          fontSize: "20px",
                          cursor: "pointer",
                          color: "#2B70D7",
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Warehouse :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.wareHouse.name.replace(/_/g, " ")}
                  </p>
                </div>

                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status
                    </p>
                    {item.status === true ? (
                      <div className="flex">
                        <p className="text-lg font-medium capitalize">
                          Active{" "}
                        </p>
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                          }
                        />
                      </div>
                    ) : (
                      <div className="flex">
                        <p className="text-lg font-medium capitalize">
                          DeActive{" "}
                        </p>
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/WarehouseManagementList", {
                      state: {
                        id: id,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Warehouse Process Stage
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div className="my-2 mx-5 flex flex-1">
        <div
          onClick={() => {
            setWarehouseStageModalVisible(true);
            setSelectedItemValue(null);
          }}
          className="flex justify-content-center align-items-center mx-2 cursor-pointer"
        >
          <div>
            <img
              src={
                "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Quick_add_customer.png"
              }
              style={{ width: 27 }}
            />
          </div>
        </div>
        <div className="flex-1">
          <IconField iconPosition="left" className="flex flex-1">
            <InputIcon className="pi pi-search text-xl"> </InputIcon>
            <InputText
              placeholder={"Search Warehouse"}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="text-xl flex flex-1 py-1 px-5"
              style={{ borderRadius: 30 }}
            />
          </IconField>
        </div>

        {searchTerm && (
          <div
            className="flex justify-content-center align-items-center mx-2 cursor-pointer"
            onClick={handleClearSearch}
          >
            <div>
              <p className="text-4xl font-bold " style={{ color: "red" }}>
                X
              </p>
            </div>
          </div>
        )}
      </div>
      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : warehouseStageData?.length > 0 &&
          filteredUserData.length > 0 > 0 ? (
          <div>
            <div>{renderCardItem(filteredUserData || warehouseStageData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Warehouse Data Present</p>
          </div>
        )}
      </div>
      <WHProcessStageListAppServiceAddModal
        wHProcessStageListAppServiceAddModalVisible={
          wHProcessStageListAppServiceAddModalVisible
        }
        setWHProcessStageListAppServiceAddModalVisible={
          setWHProcessStageListAppServiceAddModalVisible
        }
        sendDataToAppService={receiveDataFromAppServiceAddModal}
        brandId={brandId}
        selectedAppServiceValue={selectedAppServiceValue}
        selectedItemValue={selectedItemValue}
      />
      <WarehouseProcessStageCreateModal
        setWarehouseStageModalVisible={setWarehouseStageModalVisible}
        warehouseStageModalVisible={warehouseStageModalVisible}
        sendDataToWarehouseStageModal={receiveDataFromWarehouseStageModal}
        warehouseId={id}
        selectedItemValue={selectedItemValue}
      />
      <WarehouseProcessStageSwapModal
        setWarehouseProcessStageSwapModalVisible={
          setWarehouseProcessStageSwapModalVisible
        }
        warehouseProcessStageSwapModalVisible={
          warehouseProcessStageSwapModalVisible
        }
        sendDataToWarehouseStageModal={receiveDataFromWarehouseStageModal}
        warehouseId={id}
        selectedItemValue={selectedItemValue}
        warehouseStageData={warehouseStageData}
      />

      <WHProcessStageListViewAppServiceAddModal
        wHProcessStageListViewAppServiceAddModalVisible={
          wHProcessStageListViewAppServiceAddModalVisible
        }
        setWHProcessStageListViewAppServiceAddModalVisible={
          setWHProcessStageListViewAppServiceAddModalVisible
        }
        // sendDataToAppService={receiveDataFromAppServiceAddModal}
        // brandId={brandId}
        // selectedAppServiceValue={selectedAppServiceValue}
        selectedItemValue={selectedItemValue}
      />

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default WarehouseProcessStageList;
